import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { updateComponent } from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import { camelize, getValidationsResult /* , cleanupString */ } from '../../utils'

import moment from 'moment'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class TextArea extends Component {
  constructor(props) {
    super(props)
    moment.locale('it')
    this.state = {
      value: props.component.value || ''
    }
  }

  componentDidMount() {
    if (
      !!this.props.component.value &&
      this.props.component.hasOwnProperty('validations') &&
      this.props.component.validations.hasOwnProperty('url')
    ) {
      const { component, dispatch } = this.props
      dispatch(updateComponent(component.id, { value: component.value }))
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.component && nextProps.component.value !== this.state.value) {
      this.setState({
        value: nextProps.component.value
      })
    }
  }
  handleChange(e) {
    const val = e.target.value
    const { component, dispatch } = this.props
    this.setState({ value: val }, () => {
      dispatch(updateComponent(component.id, { value: val }))
    })
  }
  validateRequired() {
    const { component } = this.props
    if (
      component.validations &&
      component.validations.isRequired &&
      !component.isDisabled
    ) {
      return true
    }
    return false
  }

  getProperErrorMessage() {
    const { component } = this.props

    if (!!component.validations.overrides) {
      const validationResult = getValidationsResult({
        component,
        type: 'overrides'
      })
      if (!validationResult.result) {
        return validationResult.errorMessage
      }
    }
    return component.errorMessage[0]
  }
  render() {
    const { widget, component } = this.props
    return (
      <div {...css(this.props.styles.component)}>
        <textarea
          placeholder={component.cleanName}
          value={this.state.value}
          onChange={this.handleChange.bind(this)}
          {...css(
            this.props.styles.input,
            component.status.indexOf('error') > -1 &&
              this.props.styles['input--invalid'],
            component.status.indexOf('loading') > -1 &&
              this.props.styles['input--blink']
          )}
          disabled={
            !!component.isDisabled ||
            component.status.indexOf('readonly') > -1 ||
            widget.status.indexOf('readonly') > -1
          }
          rows={component.rows}
          cols={component.cols}
          maxLength={component.maxLength}
          name={component.id}
        />
        <span
          {...css(
            this.props.styles.label,
            this.state.value !== '' && this.props.styles['label--active']
          )}
        >
          {component.cleanName}
        </span>
        <small {...css(this.props.styles['error-msg'])}>
          {camelize(this.getProperErrorMessage(), true, true)}
        </small>
        {!!component.hint && !!component.hint.visible ? (
          <span {...css(this.props.styles.hint)}>
            {this.props.component.hint.value}
          </span>
        ) : (
          ''
        )}
      </div>
    )
  }
}

TextArea.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const { components } = state
  return { component: components[ownProps.component.id] }
}

export default connect(mapStateToProps)(withStyles(Styles)(TextArea))



// WEBPACK FOOTER //
// ./components/textArea/index.js